import { Takk } from "@mjolnerbacken/shared/types/takk";

import { SafeImage } from "./safe-image";

export function TakkImage({
  takk,
  className,
  withLabel = true,
}: {
  takk: Takk;
  className?: string;
  withLabel?: boolean;
}) {
  return (
    <div
      className={`relative flex items-center p-2 justify-center w-[100px] h-[100px] border border-gray-300 rounded-lg bg-white overflow-hidden ${className ?? ""}`}
    >
      <SafeImage
        alt="Takk"
        className="object-cover object-center"
        fallback={<div>Loading...</div>}
        src={takk.imageUrl}
      />
      {withLabel && (
        <div className="absolute bottom-0 left-0 right-0 p-2 text-center text-shadow-md">
          {takk.title}
        </div>
      )}
    </div>
  );
}
